import React from 'react';

const HourglassSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -960 960 960"
      strokeWidth="1.5"
      {...props}
    >
      <path
        d="M316.15-160h327.7v-120q0-68.31-47.77-116.85-47.77-48.54-116.08-48.54t-116.08 48.54Q316.15-348.31 316.15-280v120ZM480-514.61q68.31 0 116.08-48.54 47.77-48.54 47.77-116.85v-120h-327.7v120q0 68.31 47.77 116.85 47.77 48.54 116.08 48.54ZM180-100v-60h76.16v-120q0-67.54 36.96-122.96 36.96-55.43 97.96-77.04-61-22-97.96-77.23-36.96-55.23-36.96-122.77v-120H180v-60h600v60h-76.16v120q0 67.54-36.96 122.77Q629.92-502 568.92-480q61 21.61 97.96 77.04 36.96 55.42 36.96 122.96v120H780v60H180Z"
      />
    </svg>
  );
};

export { HourglassSVG };